<template>
    <div v-if="$store.state.success.show" class="success-page">
        <span class="bee-success-container">
            <img src="../assets/img/oskar-rainbow-plain.svg" class="bee-success slide-in-blurred-bl" />
        </span>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.success-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3);
    z-index: 10000;
}

.bee-success-container {
    width: 50%;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.bee-success {
    display: block;
    margin: 0 auto;
    width: 15rem;
    -o-object-fit: contain;
    object-fit: contain;
}

.slide-in-blurred-bl {
    -webkit-animation: slide-in-blurred-bl 2s cubic-bezier(0.23, 1, 0.32, 1) both;
    animation: slide-in-blurred-bl 2s cubic-bezier(0.23, 1, 0.32, 1) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-2-6 14:44:8
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-blurred-bl
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-blurred-bl {
    0% {
        -webkit-transform: translate(-1000px, 1000px) skew(-80deg, -10deg);
        transform: translate(-20rem, 20rem) skew(-30deg, -3deg);
        -webkit-transform-origin: 100% 100%;
        transform-origin: 100% 100%;
        -webkit-filter: blur(10px);
        filter: blur(10px);
        opacity: 0;
    }
    33% {
        -webkit-filter: blur(0);
        filter: blur(0);
        opacity: 1;
    }
    66% {
        -webkit-filter: blur(10px);
        filter: blur(10px);
        opacity: 0.4;
    }
    100% {
        -webkit-transform: translate(0, 0) skew(0deg, 0deg);
        transform: translate(20rem, -20rem) skew(0deg, 0deg);
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        -webkit-filter: blur(0);
        filter: blur(0);
        opacity: 1;
    }
}
@keyframes slide-in-blurred-bl {
    0% {
        -webkit-transform: translate(-1000px, 1000px) skew(-80deg, -10deg);
        transform: translate(-20rem, 20rem) skew(-30deg, -3deg);
        -webkit-transform-origin: 100% 100%;
        transform-origin: 100% 100%;
        -webkit-filter: blur(10px);
        filter: blur(10px);
        opacity: 0;
    }
    33% {
        -webkit-filter: blur(0);
        filter: blur(0);
        opacity: 1;
    }
    66% {
        -webkit-filter: blur(10px);
        filter: blur(10px);
        opacity: 0.4;
    }
    100% {
        -webkit-transform: translate(0, 0) skew(0deg, 0deg);
        transform: translate(20rem, -20rem) skew(0deg, 0deg);
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        -webkit-filter: blur(10px);
        filter: blur(10px);
        opacity: 0;
    }
}
</style>
